const BASE_URL = import.meta.env.VITE_BASE_API_URL;

// Credit Score
export const CreditScoreQuestions = `${BASE_URL}/deals/api/credit-report/soft/questions`;
export const CreditScoreSoftAssessment = `${BASE_URL}/deals/api/credit-report/soft/assessment`;
export const PublicLeadCreationOldUrl = `${BASE_URL}/leads/public/api/lead/`;
export const EmployeeHistoryUrl = `${BASE_URL}/leads/public/api/lead-information/`;
export const CreditScoreForProve = `${BASE_URL}/deals/api/credit-report/soft-credit-report`;

// Trade In
export const PublicLeadCreationUrl = `${BASE_URL}/public/api/lead/`;
export const PublicLeadPreApprovedUrl = `${BASE_URL}/leads/public/api/preApproved/`;
export const SendOtpAPI = `${BASE_URL}/messaging/api/verify/send-otp`;
export const VerifyOtpAPI = `${BASE_URL}/messaging/api/verify/verify-otp `;
export const googleReviewAPI = `https://q8tcwvtxm7.execute-api.ca-central-1.amazonaws.com/dev/dealers/api/google/reviews-by-location`;

export const authenticateClientAPI = `${BASE_URL}/widget/api/widget/get-Widget-data`;

export const VehicleLookupAutocomplete = `${BASE_URL}/inventory/api/vehicles/blackbook/autocomplete`;
export const BlackbookVehicleOptions = `${BASE_URL}/inventory/api/vehicles/blackbook/options`;
export const BlackbookVehicleColorsByUVC = `${BASE_URL}/inventory/api/vehicles/blackbook/colors`;

export const getVehicleByVIN = `${BASE_URL}/inventory/api/vehicles/`;
export const calculatePaymentsAPI = `${BASE_URL}/deals/api/public/calculatePayments`;

export const bookAnAppointmentAPI = `${BASE_URL}/leads/public/api/lead-appointment/`;

export const getTokenAPI = `${BASE_URL}/inventory/api/vehicles/token/`;
export const getValuationAPI = `${BASE_URL}/inventory/api/vehicles/valuation/`;

//Prove
export const ProveVerificationStart = `${BASE_URL}/leads/api/prove-verification/start`;
export const ProveVerificationValidate = `${BASE_URL}/leads/api/prove-verification/validate`;
export const ProveVerificationComplete = `${BASE_URL}/leads/api/prove-verification/complete`;
